import { Loader } from "./Loader"

export const LoaderPage = () => {
    return (
        <div className="container_loader">
            <Loader />
        </div>
    )
}
